<div fxLayout="row wrap" fxLayoutAlign="center center" class="layout-wrapper">
  <div fxFlex="100%" fxFlex.lt-md="100%" class="flex-wrapper">
    <ng-content></ng-content>
  </div>
</div>
